var agreementNo;
var fundCode;

$(function() {

	toApi('intervalschangelist.tml?pagesz=10000&pageno=1', function(data) {

		if(data.fundInfos.length > 0) {
			var newinvestmentPlanlist = data.fundInfos;
			newinvestmentPlanlist.forEach(function(e, index) {
				e.index = index + 1;
				e.activateDate = e.activateDate.substring(0, 4) + "-" + e.activateDate.substring(4, 6) + "-" + e.activateDate.substring(6, 8);
				e.nextTimingDate = e.nextTimingDate.substring(0, 4) + "-" + e.nextTimingDate.substring(4, 6) + "-" + e.nextTimingDate.substring(6, 8);
				e.isShow = (e.agreementType === '04') ? 'none' : '';
				e.timingAmount = toThousands(e.timingAmount);
				e.totalAmount = toThousands(e.totalAmount);
				e.dateOfDeduction = (function(timingCycle, timingDate) {
					timingDate = Number(timingDate);
					if(timingCycle === '1') {
						return '每月' + timingDate + '号';
					}
					if(timingCycle === '2') {
						return '每日';
					}
					var dateDesc = {
						"1": "一",
						"2": "二",
						"3": "三",
						"4": "四",
						"5": "五"
					};
					if(timingCycle === '0') {
						return '每周周' + dateDesc[timingDate];
					}
					if(timingCycle === '3') {
						return '每双周周' + dateDesc[timingDate];
					}
					if(timingCycle === '4') {
						return '每双月' + timingDate + '号';
					}
					return ''
				})(e.timingCycle, e.timingDate);
			});

			var htmlList = template('tpl_investmentplan', {"list": newinvestmentPlanlist});
			$('#implanap').html(htmlList);
		}else {
			var noneHtml = '<div class="hold-box h-min">';
			noneHtml += '<p class="no-data">暂无定期转换基金</p>';
			noneHtml += '</div>';
			$('#surely-list').html(noneHtml);
		}
	});
});

function before(){
    $('#wdoffervi').removeClass('pup-model');
    $('#wdoffervi').addClass('none');
}


function next(){
    $('#wdoffervi').removeClass('pup-model');
    $('#wdoffervi').addClass('none');
    document.getElementById("wdoffervi2").style.display = '';
    $('#wdoffervi2').removeClass('none');
    $('#wdoffervi2').addClass('pup-model');
}

function back(){
    closeKeypad();
    $('#paySc').val('');
    $('#wdoffervi2').removeClass('pup-model');
    $('#wdoffervi2').addClass('none');
}

function wdoffer(urlagreementNo,urlfundCode){
    document.getElementById("wdoffervi").style.display = '';
    agreementNo = urlagreementNo;
    fundCode = urlfundCode;
    $('#wdoffervi').removeClass('none');
    $('#wdoffervi').addClass('pup-model');
}

function wdoffernext() {
	closeKeypad();
	$('#e_paySc').addClass('none');
	if(isNull($('#paySc').val())) {
		errShow('paySc', '交易密码还未输入，请先输入交易密码');
		return;
	}
	if(!checkTransPwd2("paySc", '交易密码不合法')) {
		return;
	}
	var paySc = $('#paySc').val();
	$('#paySc').val('');
	//通过[密钥下发]接口获取密码RSA秘钥
	toApi('getPubKey.tml?type=' + 2, function(data) {

		var publicKey = data.key;
		var r_p = RSAUtil_transPwd(paySc, publicKey);
		toApi('changeinvestment.tml?modifyType=3&transPwd=' + r_p + '&agreementNo=' + agreementNo + '&fundCode=' + fundCode + '', function(data) {
			$('#wdoffervi2').removeClass('pup-model');
			$('#wdoffervi2').addClass('none');
			var alertH = '<div class="tipMsgCover" id="popalert">'
				+ '<div class="pup-box">'
				+ '<img class="imgtips"  src="' + phURL + 'images/tips/reg-tips-gt.jpg">'
				+ '<div class="tips-font">定投计划终止成功</div>'
				+ '<p><a href="javascript:void(0)" class="btn-blue" onclick="location.reload();">我知道了</a></p>'
				+ '</div>'
				+ '</div>';
			$('body').append(alertH);
		});
	});
}

function record(urlagreementNo, fundName, fundCode) {
	window.location.href = phURL + "account/mytransactionrecord.html?urlagreementNo=" + urlagreementNo + "&fundName=" + encodeURI(fundName) + "&fundCode=" + encodeURI(fundCode) + '&conversion=1';
}